import React, { useRef, useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import './FullScreenTableWrapper.css';

export const FullScreenTableWrapper = ({ children, className = '', style = {}, hideButton = false, onToggleRef }) => {
  const containerRef = useRef(null);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleToggle = () => {
    setIsFullScreen(prev => !prev);
  };

  // Expose toggle function to parent via ref
  if (onToggleRef) {
    onToggleRef.current = handleToggle;
  }

  const innerIconDimension = 25;
  const innerIconBorderRadius = 100;
  const innerIconPadding = 3;
  return (
    <Box
      ref={containerRef}
      className={`${className} ${isFullScreen ? 'fullscreen-wrapper' : ''}`}
      style={{ position: 'relative', ...style, opacity: '1', width: '100%', height: '100%' }}
    >
      {!hideButton && (
        <Tooltip title={isFullScreen ? 'Exit Fullscreen' : 'Enter Fullscreen'} sx={{ background: 'rgba(255, 255, 255, 0.3)' }}>
          <IconButton
            size="small"
            onClick={handleToggle}
            sx={{
              position: 'absolute',
              top: -5,
              right: 0,
              zIndex: 1400,
              width: '25px',
              height: '25px',
              backgroundColor: 'transparent',

            }}
          >
            {isFullScreen ?
              <FullscreenExitIcon sx={{
                background: 'rgba(255, 255, 255, 0.45)',
                width: `${innerIconDimension}px`,
                height: `${innerIconDimension}px`,
                borderRadius: `${innerIconBorderRadius}%`,
                padding: `${innerIconPadding}px`,
                '&: hover': {
                  backgroundColor: 'transparent',
                },
              }}
              /> :
              <FullscreenIcon sx={{
                background: 'rgba(255, 255, 255, 0.45)',
                width: `${innerIconDimension}px`,
                height: `${innerIconDimension}px`,
                borderRadius: `${innerIconBorderRadius}%`,
                padding: `${innerIconPadding}px`,
                '&: hover': {
                  backgroundColor: 'transparent'
                }
              }}
              />}
          </IconButton>
        </Tooltip>
      )}
      {children}
    </Box>
  );
};
